<template>
    <article>
        <h1>Final Fantasy Tactics Custom Maps</h1>
        <h3>2021</h3>

        <section>
            <div class="links">
                <p>
                    <a href="/downloads/garmichaels-fft-custom-maps.zip">Download the Maps</a>
                </p>
            </div>
            <div class="one-column">
                <p>
                    These are some maps I made with <router-link to="/GaneshaDx">Ganesha Dx</router-link>.
                </p>

                <p>
                    I have offered the maps a a download, but retain any rights to use. You may not distribute, alter,
                    or otherwise use these maps in any capacity outside of personal education.
                </p>

            </div>

            <div class="one-column">
                <h2>Mako Reactor (from Final Fantasy VII)</h2>
                <img src="../assets/page-fft-maps/Mako-Reactor.png" alt="Final Fantasy Tactics Map: Mako Reactor">

                <h2>Enhasa, Kingdom of Zeal (from Chrono Trigger)</h2>
                <img src="../assets/page-fft-maps/Enhasa.png" alt="Final Fantasy Tactics Map: Enhasa, Kingdom of Zeal">

                <h2>Arris Dome (from Chrono Trigger)</h2>
                <img src="../assets/page-fft-maps/Arris-Dome.png" alt="Final Fantasy Tactics Map: Arris Dome">

                <h2>End of Time (from Chrono Trigger)</h2>
                <img src="../assets/page-fft-maps/End-of-Time.png" alt="Final Fantasy Tactics Map: End of Time">

                <h2>Green Hill Zone (from Sonic the Hedgehog)</h2>
                <img src="../assets/page-fft-maps/Green-Hill-Zone.png" alt="Final Fantasy Tactics Map: Green Hill Zone">

                <h2>Shadow Moses (from Metal Gear Solid)</h2>
                <img src="../assets/page-fft-maps/Shadow-Moses.png" alt="Final Fantasy Tactics Map: Shadow Moses">

                <h2>Yharnam (from Bloodborne)</h2>
                <img src="../assets/page-fft-maps/Yharnam.png" alt="Final Fantasy Tactics Map: Yharnam">
            </div>
        </section>
    </article>
</template>

<script>
    export default {
        name: "FFTMaps"
    }
</script>